import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';

import cartMiddleware, { getCartState } from 'data/middleware/cartMiddleware';
import pageTrackerMiddleware from 'data/middleware/pageTrackerMiddleware';
import sessionMiddleware, {
	getSessionState,
} from 'data/middleware/sessionMiddleware';
import pusherMiddleware from 'data/middleware/pusherMiddleware';
import { dataConfig } from 'data/dataConfig';
import { getReducerName } from 'data/dataSourceConstants';

import genericDataSetReducer from 'reducers/genericDataSetReducer';
import acrisRealPropertyMasterReducer from 'reducers/acrisRealPropertyMasterReducer';
import addressReducer from 'reducers/addressReducer';
import adminPortfoliosReducer from 'reducers/adminPortfoliosReducer';
import adminNotificationsReducer from 'reducers/adminNotificationsReducer';
import adminUsersReducer from 'reducers/adminUsersReducer';
import cartReducer from 'reducers/cartReducer';
import complianceDatesPortfolioReducer from 'reducers/complianceDatesPortfolioReducer';
import documentRequestReducer from 'reducers/documentRequestReducer';
import ecbInfractionCodeReducer from 'reducers/ecbInfractionCodeReducer';
import emailPreferencesReducer from 'reducers/emailPreferencesReducer';
import exportReducer from 'reducers/exportReducer';
import fileReducer from 'reducers/fileReducer';
import firstLoadTasksReducer from 'reducers/firstLoadTasksReducer';
import mapReducer from 'reducers/mapReducer';
import missingPropertyReducer from 'reducers/missingPropertyReducer';
import modalReducer from 'reducers/modalReducer';
import notificationsReducer from 'reducers/notificationsReducer';
import overviewDataSetReducer from 'reducers/overviewDataSetReducer';
import ownersReducer from 'reducers/ownersReducer';
import portfolioReducer from 'reducers/portfolioReducer';
import portfolioSettingsReducer from 'reducers/portfolioSettingsReducer';
import portfoliosManagementReducer from 'reducers/portfoliosManagementReducer';
import propertyManagementReducer from 'reducers/propertyManagementReducer';
import propertyReducer from 'reducers/propertyReducer';
import propertyListReducer from 'reducers/propertyListReducer';
import recordDetailsReducer from 'reducers/recordDetailsReducer';
import recordSearchReducer from 'reducers/recordSearchReducer';
import sidebarReducer from 'reducers/sidebarReducer';
import tempAuthTokenReducer from 'reducers/tempAuthTokenReducer';
import toastReducer from 'reducers/toastReducer';
import topViolationsReducer from 'reducers/topViolationsReducer';
import uiStateReducer from 'reducers/uiStateReducer';
import userReducer from 'reducers/userReducer';
import userSearchReducer from 'reducers/userSearchReducer';
import zoningReducer from 'reducers/zoningReducer';
import pricingReducer from 'reducers/pricingReducer';
import subscriptionReducer from 'reducers/subscriptionReducer';
import akaReducer from 'reducers/akaReducer';
import { adminSubscriptionsReducer } from 'data/repositories/adminSubscriptionsRepository';
import { adminUsersReducer as adminUsersRepoReducer } from 'data/repositories/adminUsersRepository';
import { subscriptionPlansReducer } from 'data/repositories/subscriptionPlansRepository';
import sidewalkReducer from 'reducers/sidewalkReducer';
// import queueMonitorReducer from 'reducers/queueMonitorReducer';
import blockAndLotSearchReducer from 'reducers/blockAndLotSearchReducer';
import resolveViolationsReducer from './reducers/resolveViolationsReducer';
import representOathHearingsReducer from './reducers/representOathHearingsReducer';
import { queueMonitorReducer } from 'data/repositories/queueMonitorRepository';
import { datasetMonitorReducer } from 'data/repositories/datasetMonitorRepository';
import { adminEmailTrackingReducer } from 'data/repositories/adminEmailTrackingRepository';
import { adminSmsResponsesReducer } from 'data/repositories/adminSmsResponsesRepository';
import { organizationsReducer } from 'data/repositories/organizationsRepository';
import { airtableReducer } from 'data/repositories/airtableRepository';
import { propertyRepoReducer } from 'data/repositories/propertyRepository';
import { certificatesOfOccupancyReducer } from 'data/repositories/certificatesOfOccupancyRepository';
import { portfolioPropertiesReducer } from 'data/repositories/portfolioPropertiesRepository';

export const history = createBrowserHistory();

let reducers = {
	acrisRealPropertyMaster: acrisRealPropertyMasterReducer,
	address: addressReducer,
	adminNotifications: adminNotificationsReducer,
	adminPortfolios: adminPortfoliosReducer,
	adminUsers: adminUsersReducer,
	cart: cartReducer,
	complianceDatesPortfolio: complianceDatesPortfolioReducer,
	documentRequest: documentRequestReducer,
	ecbInfractionCode: ecbInfractionCodeReducer,
	emailPreferences: emailPreferencesReducer,
	exportReducer: exportReducer,
	files: fileReducer,
	firstLoadTasks: firstLoadTasksReducer,
	map: mapReducer,
	missingProperty: missingPropertyReducer,
	modal: modalReducer,
	notifications: notificationsReducer,
	overviewDataSet: overviewDataSetReducer,
	owners: ownersReducer,
	aka: akaReducer,
	portfolio: portfolioReducer,
	portfolioSettings: portfolioSettingsReducer,
	portfoliosManagement: portfoliosManagementReducer,
	propertyManagement: propertyManagementReducer,
	property: propertyReducer,
	propertyList: propertyListReducer,
	recordDetails: recordDetailsReducer,
	recordSearch: recordSearchReducer,
	sidebar: sidebarReducer,
	tempAuthToken: tempAuthTokenReducer,
	toast: toastReducer,
	topViolations: topViolationsReducer,
	uiState: uiStateReducer,
	user: userReducer,
	userSearch: userSearchReducer,
	zoning: zoningReducer,
	pricing: pricingReducer,
	subscription: subscriptionReducer,
	adminSubscriptions: adminSubscriptionsReducer,
	adminUsersRepo: adminUsersRepoReducer,
	subscriptionPlans: subscriptionPlansReducer,
	sidewalk: sidewalkReducer,
	queueMonitor: queueMonitorReducer,
	datasetMonitor: datasetMonitorReducer,
	blockAndLotSearch: blockAndLotSearchReducer,
	resolveViolations: resolveViolationsReducer,
	representOathHearings: representOathHearingsReducer,
	adminEmailTracking: adminEmailTrackingReducer,
	adminSmsResponses: adminSmsResponsesReducer,
	organizations: organizationsReducer,
	airtable: airtableReducer,
	propertyRepo: propertyRepoReducer,
	certificatesOfOccupancy: certificatesOfOccupancyReducer,
	portfolioProperties: portfolioPropertiesReducer,
};
export const actions = {};

const initialState = Object.assign({}, getSessionState(), getCartState());

Object.keys(dataConfig).forEach((key) => {
	let configObj = dataConfig[key];
	configObj.dataSources.forEach((dataSource) => {
		let { reducer, fetchData, fetchAllPages, setPage, silentRefresh } = genericDataSetReducer(
			configObj,
			dataSource,
		);
		let reducerName = getReducerName(configObj, dataSource);
		reducers[reducerName] = reducer;
		actions[reducerName] = {
			fetchData,
			fetchAllPages,
			setPage,
			silentRefresh,
		};
	});
});

const createRootReducer = (history) =>
	combineReducers({
		router: connectRouter(history),
		...reducers,
	});

//hook up redux dev tools extension
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
	createRootReducer(history),
	initialState,
	composeEnhancers(
		applyMiddleware(
			routerMiddleware(history),
			cartMiddleware,
			sessionMiddleware,
			pageTrackerMiddleware,
			pusherMiddleware,
			thunk,
		),
	),
);

export const dispatch = store.dispatch;

window.store = () => store.getState(); //debug
window.actions = () => actions; //debug

export default store;
